<script setup lang="ts">
import { computed, useAttrs, type InputHTMLAttributes } from "vue";
import { convertDeprecatedSize, type DeprecatedSizeProps } from "../../lib/size";
import FormField, { type FormFieldProps } from "../form/FormField.vue";
import type { FileInputProps } from "./FileInput.vue";
import FileInput from "./FileInput.vue";

defineOptions({ inheritAttrs: false });

interface Props
	extends FileInputProps,
		DeprecatedSizeProps,
		FormFieldProps,
		/* @vue-ignore */ Omit<InputHTMLAttributes, keyof FileInputProps | keyof FormFieldProps> {}

const props = defineProps<Props>();
const attrs = useAttrs();

const modelValue = defineModel<File>();

const size = computed(() => {
	if (props.size != null) {
		return props.size;
	}

	return convertDeprecatedSize(props) || undefined;
});

function attrsClassExtractor(attrs: Readonly<Record<string, unknown>>) {
	const copy = { ...attrs };
	const _class = copy.class as string;
	delete copy.class;

	return {
		class: _class || "",
		attrs: copy,
	};
}

const attributes = computed(() => {
	return attrsClassExtractor(attrs);
});
</script>

<template>
	<FormField :label="label" :errors="errors" :hint="hint" :class="attributes.class">
		<FileInput
			v-model="modelValue"
			:size="size"
			:color="color"
			:variant="variant"
			v-bind="attributes.attrs"
		/>
	</FormField>
</template>
